import { render, staticRenderFns } from "./ModulesLayout.vue?vue&type=template&id=5c0e4028"
import script from "./ModulesLayout.vue?vue&type=script&lang=ts"
export * from "./ModulesLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports